import { Component, OnInit, Input } from '@angular/core';

import { CommonService } from '../services/common.service';
import { CacheService } from '../services/cache.service';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { AppMessageService } from '../../app-message.service';
import { CookieBannerType } from '../enums/cookie-banner-type';
import { environment } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { CookieBannerMessageType } from '../../shared/enums/cookie-message-types.enum';
import { Translations } from '../constants/translations.constants';

@Component({
    selector: 'app-cookie-banner',
    templateUrl: '../templates/template1/views/app-cookie-banner.component.html',
    styleUrls: ['../templates/template1/themes/default/less/app-cookie-banner.less']
})

export class AppCookieBannerComponent implements OnInit {

    @Input() bannerTitle = '';
    @Input() bannerDescription = '';
    @Input() bannerNotificationType = 0;
    bannerMessageType = '';
    showCookieBanner = true;
    termsAndConditionsUrl: string;
    isoCountryCode: string;
    language: string;
    isImpersonatedUser: boolean;
    scrollRetainPos = 0;

    ngOnInit(): void {
      
        this.setToDefaultData();
        this.showCookieBanner = this._cacheService.getCookieValue(CacheKey.CookieBanner) ? false : true;
        this.isoCountryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
        this.language = this._commonService.getLanguageCode();
        this.isImpersonatedUser = this._cacheService.get(CacheKey.ImpersonatedUser);
        this._appMessageService.getCookieBannerData().subscribe((data) => {
            if (data.showBanner) {
                if (data.showDefault) {
                    this.setToDefaultData();
                } else {
                    this.bannerTitle = data.title;
                    this.bannerDescription = data.description;
                    this.bannerNotificationType = data.notificationType;
                    if (data.notificationMessageType) {
                        this.bannerMessageType = data.notificationMessageType;
                    }
                }
                this.showCookieBanner = true;
                $('div.cookies-content').focus();
                // hiding cookie
                if (data && data.timeout && data.time) {
                    setTimeout(() => {
                        this.showCookieBanner = false;
                    }, data.time);
                }
            } else {
                this.showCookieBanner = false;
            }
        });
        this.termsAndConditionsUrl = environment.cdnURL + '/flpi/documents/Terms_Conditions_June2016.pdf';

    }
    constructor(
        private _commonService: CommonService,
        private _cacheService: CacheService,
        private _translatePipe: TranslateService,
        private _appMessageService: AppMessageService
    ) { }

    hideCookie(isContinue: boolean) {
        const cookieExpiryDate: Date = new Date((new Date()).valueOf() + 1000 * 60 * 60 * 24 * environment.cookieExpiryDays);
        if (isContinue) {
            if (this.bannerNotificationType === CookieBannerType.CartItemNotification) {
                const responseData = { canShowSplash: false, saveSettings: true };
                this._appMessageService.setCookieBannerResponseData(responseData);
                // if the notification is regarding to favourites then navigating to login page
                // tslint:disable-next-line:max-line-length
                if (this.bannerMessageType === CookieBannerMessageType.Favourites) {
                    this._cacheService.set(CacheKey.RedirectToFavourites, true);
                    this.gotoLogin(true); // navigates to login page
                }
            } else {
                this._cacheService.setCookieValue(CacheKey.CookieBanner, 'false');
            }
        } else {
            if (this.bannerNotificationType === CookieBannerType.CartItemNotification) {
                const responseData = { canShowSplash: false, saveSettings: false };
                this._appMessageService.setCookieBannerResponseData(responseData);
                if (this.showCookieBanner) {
                    this.setToDefaultData();
                }
                this.setBodyFixed(false);
            } else {
                this._cacheService.setCookieValue(CacheKey.CookieBanner, 'false');
            }
        }
        this.showCookieBanner = this._cacheService.getCookieValue(CacheKey.CookieBanner) ? false : true;
    }
    /**
     * redirect to sso login url
     * @param  {boolean} isLogin
     * @returns void
    */
    gotoLogin(isLogin: boolean): void {
        this._appMessageService.setNotifyLoginStatus(isLogin);
    }

    /**
      * to make background unaccessible while collapsible shown
      * @param  {boolean} setFixed
      * @returns void
      */
  setBodyFixed(setFixed: boolean, isOutsideClick?: boolean): void {
    // To resolve the screen right shifting, when any popup or country selection opened.
    this._commonService.jumpingScroll(setFixed);
    if (setFixed) {
      this.scrollRetainPos = document.documentElement.scrollTop || document.body.scrollTop;
      document.body.style.position = 'fixed';
    } else {
      document.body.style.position = 'static';
      if (isOutsideClick) {
        this.scrollRetainPos = 0;
      }
      this._commonService.scrollByValue(0, this.scrollRetainPos, 0);
    }
  }

    setToDefaultData() {
        // tslint:disable-next-line:max-line-length
        // this._translatePipe.get('cookieBanner.We use cookies. By closing this message or continuing to browse the site, you are agreeing the application to use the cookies. For more information on our cookie policy')
        //     .subscribe(res => {
        this.bannerTitle = 'Cookies on the Forever Living website';
        this.bannerDescription = Translations.COOKIE_USAGE_MESSAGE;
        this.bannerNotificationType = CookieBannerType.Default;
        // });
    }

}
